import { API_URLS } from '_constants';
import * as TYPES from './CourtsList.types';

export const getCourtsList = () => {
  return {
    types: [TYPES.GET_COURTS_LIST, TYPES.GET_COURTS_LIST_SUCCESS, TYPES.GET_COURTS_LIST_FAIL],
    promise: (client) => client.get(`${API_URLS.courtsList}?page_size=100`),
  };
};
